/* eslint-disable */
import { produce } from "immer";
import {
  FC_FLEXI_LINECHART_FETCH_FAILURE,
  FC_FLEXI_LINECHART_FETCH_SUCCESS,
  FC_FLEXI_LINECHART_FETCH_START,
} from "../actions/types";

const futurecalculatorFlexiLinechart = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case FC_FLEXI_LINECHART_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case FC_FLEXI_LINECHART_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case FC_FLEXI_LINECHART_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default futurecalculatorFlexiLinechart;
